<div [class]="'w-full text-medium '+customContainerlass"
    [ngClass]="{'flex': labelPosition === 'left' || labelPosition === 'right'}">
    <div *ngIf="label&&labelPosition === 'left'" [class]="'self-center mr-3 font-semibold ' + customLabel">{{label}}
        <ng-content select="[labelLeft]"></ng-content>
    </div>
    <div *ngIf="label&&labelPosition === 'top'" [class]="'self-center mb-2 font-semibold ' + customLabel">{{label}}
        <ng-content select="[labelTop]"></ng-content>
    </div>
    <div class="flex w-full">
        <ng-content select="[iconLeft]"></ng-content>
        @if(type!== 'textarea'){<input (ngModelChange)="onInputChange($event)" (keyup)="checkEnter($event)"
            [(ngModel)]="value" [value]="value" [placeholder]="placeholder" [type]="type"
            [class]="'w-full outline-none px-3 py-1 rounded-lg border-[1px] border-[#6B7280] ' + customInputClass">}
        @if(type=== 'textarea'){<textarea (ngModelChange)="onInputChange($event)" (keyup)="checkEnter($event)"
            [(ngModel)]="value" [value]="value" [placeholder]="placeholder"
            style="height: auto !important;"
            [class]="'w-full outline-none custom-input-text-area px-3 py-1 rounded-lg border-[1px] border-[#6B7280] ' + customInputClass"></textarea>}
        <ng-content select="[iconRight]"></ng-content>
    </div>
    <div *ngIf="label&&labelPosition === 'right'" [class]="'self-center ml-3 font-semibold ' + customLabel">{{label}}
        <ng-content select="[labelRight]"></ng-content>
    </div>
    <div *ngIf="label&&labelPosition === 'bottom'" [class]="'self-center mt-2 font-semibold ' + customLabel">{{label}}
        <ng-content select="[labelBottom]"></ng-content>
    </div>
</div>